import React from 'react';
import { Container, Box, Typography, TextField, Button, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import DrawIcon from '@mui/icons-material/Draw';

const SignUp = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your sign-up logic here
    console.log('Sign up submitted');
  };

  return (
    <div className="min-h-screen">
      <Header />
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            bgcolor: 'white',
            borderRadius: 2,
            boxShadow: 3,
            p: 4
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
            <DrawIcon sx={{ fontSize: 40, color: theme.palette.brand.brand }} />
            <Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.brand.brand }}>
              Fence Sketch
            </Typography>
          </Box>
          
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
            Create Your Account
          </Typography>
          <Typography variant="body1" sx={{ color: theme.palette.interactions.subtle.default, mb: 4 }}>
            Start your 14-day free trial
          </Typography>

          <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
            <TextField
              fullWidth
              label="Full Name"
              type="text"
              margin="normal"
              required
              autoFocus
            />
            <TextField
              fullWidth
              label="Email"
              type="email"
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Company Name"
              type="text"
              margin="normal"
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              margin="normal"
              required
              helperText="Must be at least 8 characters"
            />
            <TextField
              fullWidth
              label="Confirm Password"
              type="password"
              margin="normal"
              required
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{ py: 1.5, fontSize: '1.1rem', fontWeight: 600, mt: 3, mb: 2 }}
            >
              Sign Up
            </Button>

            <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', color: theme.palette.interactions.subtle.default, mb: 2 }}>
              By signing up, you agree to our Terms of Service and Privacy Policy
            </Typography>

            <Typography variant="body2" align="center" sx={{ color: theme.palette.interactions.subtle.default }}>
              Already have an account?{' '}
              <Link
                onClick={() => navigate('/signin')}
                sx={{
                  color: theme.palette.brand.brand,
                  textDecoration: 'none',
                  fontWeight: 600,
                  cursor: 'pointer',
                  '&:hover': { textDecoration: 'underline' }
                }}
              >
                Sign In
              </Link>
            </Typography>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default SignUp;



